import apiClient from './apiClient';

export const getSocialLinks = (businessId) => apiClient.get(`/social-links/${businessId}`);
